import React from 'react'
import {
  ReceivedQuestionHeader,
  ReceivedQuestionTitle,
  ReceivedQuestionBody,
  QuestionIcon,
  QuestionTitle
} from './style'
import {
  EditOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined
} from '@ant-design/icons'
import { Button, Tag } from 'antd'

const ReceivedWritten = (props) => {
  const {
    points,
    question_text,
    ans,
    text_match,
    auto_graded,
    keywords,
    question_number
  } = props.question

  return (
    <ReceivedQuestionHeader>
      <ReceivedQuestionTitle>
        <QuestionIcon>
          (Points : {points})
          <Button
            icon={<EditOutlined />}
            style={{ border: '0px', marginRight: '5px' }}
            onClick={() => props.draftQuestion(question_number)}
          ></Button>
        </QuestionIcon>
        <QuestionTitle>
          <b>Question {question_number}:</b> {question_text}
        </QuestionTitle>
      </ReceivedQuestionTitle>
      <ReceivedQuestionBody>
        <div>
          <p>
            <b>Model Answer: </b>
            {ans}
          </p>
        </div>

        <hr style={{ border: '0.5px solid #c2c2c2' }} />
        <div>
          <b>Question Type : </b> Essay &nbsp; Text match :{' '}
          {text_match ? (
            <CheckCircleOutlined
              style={{ fontSize: '16px', color: '#108ee9', margin: '5px' }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ fontSize: '16px', color: 'gray', margin: '5px' }}
            />
          )}
          &nbsp; Auto graded :{' '}
          {auto_graded ? (
            <CheckCircleOutlined
              style={{ fontSize: '16px', color: '#108ee9', margin: '5px' }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ fontSize: '16px', color: 'gray', margin: '5px' }}
            />
          )}
          &nbsp; Keywords:{' '}
          {keywords && keywords.length > 0 ? (
            keywords.map((element, index) => (
              <Tag key={index} color="red">
                {element.key_word} : {element.weight}
              </Tag>
            ))
          ) : (
            <CloseCircleOutlined
              style={{ fontSize: '16px', color: 'gray', margin: '5px' }}
            />
          )}
        </div>
      </ReceivedQuestionBody>
    </ReceivedQuestionHeader>
  )
}

export default ReceivedWritten
